import { toStringOrNull } from './generic';

export class UniqueKeyGenrator {
	private existingKeys: { [key: string]: boolean } = {};

	public addExistingKeys(keys: string[]): void {
		for (let i = 0; i < keys.length; i++) {
			this.existingKeys[keys[i]] = true;
		}
	}

	public getUniqueKey(colId: string, colField: string): string {
		// in case user passed in number for colId, convert to string
		colId = toStringOrNull(colId);

		let count = 0;
		while (true) {
			let idToTry: string;
			if (colId) {
				idToTry = colId;
				if (count !== 0) {
					idToTry += '_' + count;
				}
			} else if (colField) {
				idToTry = colField;
				if (count !== 0) {
					idToTry += '_' + count;
				}
			} else {
				idToTry = '' + count;
			}

			if (!this.existingKeys[idToTry]) {
				this.existingKeys[idToTry] = true;
				return idToTry;
			}

			count++;
		}
	}
}
